export default {"src":"/_next/static/media/template_resource.c671b112.svg","height":260,"width":363,"blurWidth":0,"blurHeight":0};